<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
  mounted() {},
  components: {
    Header,
    Footer,
  },
  // created() {
  //   this.$store.dispatch("country/fetchCountryViaIpAddress");
  // },
};
</script>
